module.exports = "/static/assets/e06143c5dc2e8bb30e70a8ab9d2cc621.png";